import { render, staticRenderFns } from "./AlertMsg.vue?vue&type=template&id=5963e1fd"
import script from "./AlertMsg.vue?vue&type=script&lang=js"
export * from "./AlertMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports